import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RoamrPage from './pages/RoamrPage';
import PrivacyPolicy from './pages/PrivacyPolicy';

const RoamrRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<RoamrPage />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
    </Routes>
  );
};

export default RoamrRoutes;